export default __webpack_public_path__ + "static/media/AnimalsBlue_01.c4db6f53.png";